export default __webpack_public_path__ + "static/media/logo.12d0d735.svg";